import { mountModule } from '@websky/core/src/__fsd__/shared/lib/mount-module';
import { enableSentry } from '@websky/core/src/utils';
import { Config, mergeConfig } from '@websky/core/src/context';
import { withConfig } from '@websky/core/src/config-hoc';

enableSentry();

import Account from './Account';
import { config as defaultConfig } from '../../config';

export const init = (mount: HTMLElement, config: Config): (() => void) => {
	const Component = withConfig(Account, mergeConfig(defaultConfig, config));

	return mountModule(Component, mount);
};
